import { AlertActionsUnion, AlertActions } from '../actions/alert.actions';
import { AlertState, initialAlertState } from '../state/alert.state';

export function alertReducer(
    state: AlertState = initialAlertState,
    action: AlertActionsUnion
): AlertState {
    switch (action.type) {
        case AlertActions.ShowAlert:
            return {
                ...state,
                message: action.payload.message,
                type: action.payload.type,
                show: true,
            };
        case AlertActions.HideAlert:
            return {
                ...state,
                show: false,
            };
        default:
            return state;
    }
}
